import React from 'react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
export function AssetProtection() {
  const {
    t
  } = useLanguage();
  return <section className="relative overflow-hidden bg-ink py-24 sm:py-32" aria-labelledby="asset-protection-heading" data-id="element-50" data-mp="26yc5603axyva">
      <div className="pointer-events-none absolute -left-40 bottom-0 h-[520px] w-[520px] rounded-full bg-brand/[0.12] blur-3xl" aria-hidden="true" data-id="element-51" data-mp="21zr6w67m1p9h" />
      <div className="relative mx-auto max-w-shell px-5 sm:px-8" data-id="element-52" data-mp="1xyywvaqwzgc5">
        <Reveal data-id="element-53" data-mp="1t5wapnogv95z">
          <div className="max-w-[720px]" data-id="element-54" data-mp="1t5css6ytgkry">
            <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-brand" data-id="element-55" data-mp="1o7uiod92bzid">
              {t.asset.eyebrow}
            </p>
            <h2 id="asset-protection-heading" className="headline mt-5 text-[32px] font-bold text-white sm:text-[46px]" data-id="element-56" data-mp="1j9sxnms2tq49">
              {t.asset.heading}
            </h2>
            <p className="mt-6 text-[17px] leading-relaxed text-white/60" data-id="element-57" data-mp="1a8bhy5ikzqg3">{t.asset.body}</p>
          </div>
        </Reveal>

        <div className="mt-16 grid gap-5 lg:grid-cols-3" data-id="element-58" data-mp="1t6u2ge86jb1z">
          <Reveal className="lg:col-span-2" data-id="element-59" data-mp="1xyli3tpsrwdc">
            <div className="grid gap-5 sm:grid-cols-2" data-id="element-60" data-mp="1xzdg1b6va66s">
              <div className="group overflow-hidden rounded-4xl border border-white/10 sm:col-span-2" data-id="element-61" data-mp="1j9patyvkends">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/728d1023-1a49-48da-b5a4-e974abdf906e.jpg" alt={t.asset.vaultAlt} className="h-[260px] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04] sm:h-[300px]" data-id="element-62" data-mp="1o8ism3hvx0jr" />
              </div>
              <div className="group overflow-hidden rounded-4xl border border-white/10" data-id="element-63" data-mp="2gv3it0mmj6lq">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/80204b4a-c7db-4c37-b521-5b5abd0a190f.jpg" alt={t.asset.entrepreneurAlt} className="h-[240px] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" data-id="element-64" data-mp="22zrd5y6xjvq1" />
              </div>
              <div className="group overflow-hidden rounded-4xl border border-white/10" data-id="element-65" data-mp="vlo9b9wt077v">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/77cf6f1d-9c97-4143-99c3-1a8b229cb8ac.jpg" alt={t.asset.officeAlt} className="h-[240px] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" data-id="element-66" data-mp="2y5gxf1v07bsf" />
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12} data-id="element-67" data-mp="2jhcm4iya62jo">
            <ul className="glass-dark h-full rounded-4xl border border-white/10 p-8" data-id="element-68" data-mp="2jg1h6ft3moqz">
              {t.asset.pillars.map((pillar, i) => <li key={pillar.title} className={`group py-5 ${i > 0 ? 'border-t border-white/10' : 'pt-0'}`} data-id="element-69" data-mp="2ago83o8w026s" data-mpi={i}>
                  <h3 className="text-[17px] font-semibold tracking-tight text-white transition-colors duration-300 group-hover:text-brand" data-id="element-70" data-mp="25hbbibs7rgr0">
                    {pillar.title}
                  </h3>
                  <p className="mt-2 text-[14px] leading-relaxed text-white/55" data-id="element-71" data-mp="3qzwgxbx7zwq">{pillar.body}</p>
                </li>)}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>;
}